import * as estimationStatuses from '@/constants/estimation_statuses';
import i18n from '@/i18n';

export default {
  data() {
    return {
      useNullableEstimationStatus: true,
    };
  },
  computed: {
    estimationStatusItems() {
      const items = [];
      if (this.useNullableEstimationStatus) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(estimationStatuses)
        .forEach((key) => {
          items.push({
            text: this.statusName(estimationStatuses[key]),
            value: estimationStatuses[key],
          });
        });
      return items;
    },
  },
  methods: {
    statusName(value) {
      if (value === estimationStatuses.ORDERED) {
        return i18n.t('estimations.interested');
      }
      return this.lang(this.$store, `sap/listings.global.filter.order_statuses.${value}`);
    },
  },
};
